import { useMutation } from '@tanstack/react-query';
import { startRecalculation } from 'config/requests/commissionRecalculationTasks';

export const useStartCommissionRecalculation = (options = {}) => {
  return useMutation({
    mutationFn: (taskId: string) => {
      if (!taskId) {
        throw new Error('ID задачи отсутствует');
      }
      return startRecalculation(taskId);
    },
    ...options,
  });
};
